export function templateVariableMapping(
  selectedDynamicValues: string[],
  dynamicValueOptions: any[]
) {
  return selectedDynamicValues
    .map((selectedValue) => {
      const option = dynamicValueOptions.find(
        (option) => option.mappingName === selectedValue
      );
      if (option) {
        return {
          fieldName: option.fieldName,
          modelType: option.modelType,
          mappingName: option.mappingName
        };
      }
      return null;
    })
    .filter(Boolean);
}
